// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__oCDeb","ranges":"BmiRanges_ranges__ZoL_3"};